import { getAttributeId } from '@/utils/productUtils';

import MillesimaPrice from '@/components/common/price/MillesimaPrice';
import { CONDITIONNEMENT_GIFTCARD_ACCESSORIES } from '@/constants/product';
import { HTML_ENTITY } from '@/constants/htmlEntity';

export const getProductModel = (product) => ({
  itemsList: [
    ...(product.items || [])
  ],
  isAlert: getAttributeId(product, 'alerte_o_n') === '1'
});

export const formatData = (t, item, locale = 'fr-FR', currencyISO = 'EUR') => {
  const {
    _id,
    attributes: {
      conditionnement: { shortValue: conditionnement, valueId: conditionnementId },
      format: { shortValue: format },
      nbunit: { value: qty }
    },
    listPrice,
    offerPrice,
    partnumber
  } = item;

  const priceToFormat = offerPrice > 0 ? offerPrice : listPrice;

  const price = MillesimaPrice.format(t, {
    value: priceToFormat,
    locale,
    currency: currencyISO
  });

  const isObjectOrGiftCard = CONDITIONNEMENT_GIFTCARD_ACCESSORIES.includes(conditionnementId);

  const label = isObjectOrGiftCard ? (
    `${HTML_ENTITY.NO_BREAK_SPACE}x${qty}${HTML_ENTITY.NO_BREAK_SPACE}`
  ) : (
    `${qty}${HTML_ENTITY.NO_BREAK_SPACE}x${HTML_ENTITY.NO_BREAK_SPACE}${conditionnement || format}`
  );

  return {
    id: _id,
    value: partnumber,
    label,
    price,
    conditionnementId
  };
};
